<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="450"
    height="100%"
    app
  >
    <v-card flat>
      <v-card-title>
        {{ adding ? 'Add Guide' : guide.name }}
      </v-card-title>
      <v-card-subtitle>
        <template v-if="adding"> Add your guide here </template>
        <v-row
          v-else
          dense
        >
          <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ guide.id }} </v-col>
          <v-col cols="auto">
            <span class="font-weight-bold">Product</span>
            {{ guide.coreProduct.name }}
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-divider v-if="!adding" />
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="guide.name"
                label="Name"
                outlined
                hide-details="auto"
                :rules="[$rules.required]"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="guide.description"
                label="Description"
                outlined
                hide-details="auto"
                :rules="[$rules.required]"
              />
            </v-col>

            <v-col
              v-if="guide.type"
              cols="12"
            >
              <v-select
                v-model="guide.type.id"
                :items="template_guide_types"
                item-text="name"
                item-value="id"
                label="Guide Type"
                outlined
                hide-details="auto"
                :rules="[$rules.required]"
              />
            </v-col>
            <v-col
              v-if="adding && guide.coreProduct"
              cols="12"
            >
              <v-select
                v-model="guide.coreProduct.id"
                :items="products"
                item-text="name"
                item-value="id"
                label="For Product"
                outlined
                hide-details="auto"
                :rules="[$rules.required]"
              />
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="guide.disableDefaultSafetyZone"
                label="Disable Safety Zone"
                color="primary"
                inset
                hide-details
              />
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="guide.isDefault"
                label="Is Default"
                color="primary"
                inset
                hide-details
              />
            </v-col>

            <v-col cols="12">
              <v-switch
                v-model="guide.active"
                label="Active"
                color="primary"
                inset
                hide-details
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          class="mb-3"
          block
          large
          outlined
          @click="openInEditor"
        >
          Open In Editor
        </v-btn>
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Save
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'EditGuide',

  components: {},

  data() {
    return {
      loading: false,
      valid: false,
      saving: false,
      gettingEditorUrl: false,
      drawer: false
    };
  },

  computed: {
    adding() {
      return !this.guide.id;
    },
    guide: {
      get() {
        return this.$store.getters['guides/edit_guide'];
      },
      set(val) {
        this.$store.dispatch('guides/edit', val);
      }
    },
    ...mapGetters({
      template_guide_types: 'lookup/template_guide_types',
      products: 'lookup/standard_products'
    })
  },

  async mounted() {
    this.$bus.$off(this.$enums.EVENT_BUS_EVENTS.EDIT_GUIDE_SHOW);
    this.$bus.$on(this.$enums.EVENT_BUS_EVENTS.EDIT_GUIDE_SHOW, (data) => {
      this.loadData(data.id);
      this.drawer = true;
    });
  },

  methods: {
    loadData(id) {
      this.loading = true;
      Promise.all([
        !id
          ? this.$store.dispatch('guides/set', {
            coreProduct: { id: 0 },
            type: {},
            active: true
          })
          : this.$store.dispatch('guides/get', id),
        this.$store.dispatch('lookup/getProducts')
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('guides/save', this.guide)
        .then(() => {
          this.drawer = false;
          this.$emit('save');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    openInEditor() {
      this.gettingEditorUrl = true;
      this.$store
        .dispatch('guides/getEditorUrl', this.guide.id)
        .then((url) => {
          window.open(url, '_blank');
        })
        .finally(() => {
          this.gettingEditorUrl = false;
        });
    }
  }
};
</script>
